import { useEffect } from 'react';
import { useNavigate, useSearch } from '@tanstack/react-router';

/**
 * Schnellknopf der Übersicht (Faruq 2026-08-24): `?neu=1` öffnet den
 * Anlegen-Dialog direkt. Der Parameter wird danach aus der Adresse entfernt,
 * damit ein Neuladen oder der Zurück-Knopf ihn nicht erneut aufzieht.
 *
 * F4 (Optimierung 2026-08-25): stand byte-gleich in CustomersPage, OrdersPage
 * und QuotesPage — jetzt EIN Hook.
 */
export function useNeuParam(oeffnen: () => void): void {
  const navigate = useNavigate();
  const neuParam = (useSearch({ strict: false }) as { neu?: string }).neu;
  useEffect(() => {
    if (neuParam !== '1') return;
    oeffnen();
    void navigate({
      to: '.',
      search: (alt: Record<string, unknown>) => ({ ...alt, neu: undefined }),
      replace: true,
    });
  }, [neuParam, navigate, oeffnen]);
}
